export enum GAEventName {
  Demo = 'demo',
}
